import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data: {
    glassOptionInput1: '',
    glassOptionInput2: '',
  },
};

export const glassoptionSlice = createSlice({
  name: 'glassoption',
  initialState,
  reducers: {
    updateValue: (state, action) => {
      state.data[action.payload.id] = action.payload.count || '';
    },
    updateDataGlassoption: (state, action) => {
      state.data = action.payload;
    },
    init: (state, action) => {
      state.data = initialState.data;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateValue, updateDataGlassoption, init } =
  glassoptionSlice.actions;

export default glassoptionSlice.reducer;
